export const getProdottoTypes = (ep62Flag) => {
    if (ep62Flag) {
        return [
            {value: "1", label: "SIM/eSim"},
            {value: "2", label: "Device"},
            {value: "3", label: "Servizi"},
        ]
    }

    return [{value: "1", label: "SIM/eSim"}, {value: "2", label: "Device"}]
}

export const assistanceType = {
    ADMINISTRATIVE: "assistenza amministrativa",
    TECHNICAL: "assistenza tecnica",
};
